module.exports = __webpack_public_path__ + "static/media/profile.136fd931.jpg";